/* eslint-disable no-console */
import SignupForm from './SignupForm';

export const Empty = {
  component: SignupForm,
  props: {
    formId: 'SignupFormExample',
    onSubmit(values) {
      
    },
    onOpenTermsOfService() {
      
    },
  },
  group: 'forms',
};
